var React = require('react');

function LinkedinLocal (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27 26.983h-3.73v-5.836c0-1.392-.024-3.182-1.938-3.182-1.94 0-2.236 1.517-2.236 3.083v5.935H15.37V14.982h3.575v1.641h.052c.497-.944 1.714-1.94 3.529-1.94 3.776 0 4.474 2.486 4.474 5.718v6.582zm-15.835-13.64a2.163 2.163 0 11-.004-4.326 2.163 2.163 0 01.004 4.325zm1.865 13.64H9.296V14.982h3.734v12.001zM18 0C8.058 0 0 8.058 0 18c0 9.94 8.058 18 18 18s18-8.06 18-18c0-9.942-8.058-18-18-18z","fill":"#5B0437"}));
}

LinkedinLocal.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = LinkedinLocal;

LinkedinLocal.default = LinkedinLocal;
